import * as React from 'react';
import { FunctionComponent } from 'react';
import { Integration } from '../../models/Integration';
import { INTEGRATION_TYPE } from '../../consts/integration';
import { SimpleModal } from '../SimpleModal/SimpleModal';
import './IntegrationAddModal.scss';

interface Props {
  items: Integration[];
  isOpen: boolean;
  onButtonClick?: (event, type) => void;
  onCloseClick?: () => void;
}

const OPTIONS = [
  {
    type: INTEGRATION_TYPE.GOOGLE_CALENDAR,
    mark: 'G',
    title: 'Google Calendar',
    text: 'Connect and synchronise Google calendars.'
  },
  {
    type: INTEGRATION_TYPE.OUTLOOK,
    mark: 'O',
    title: 'Microsoft Outlook',
    text: 'Connect calendars from your Microsoft account.'
  },
  {
    type: INTEGRATION_TYPE.I_CALENDAR,
    mark: 'i',
    title: 'iCalendar',
    text: 'Publish school events using an iCalendar feed.'
  },
  { type: INTEGRATION_TYPE.TWITTER, mark: 'X', title: 'X / Twitter', text: 'Connect your school social account.' }
];

export const IntegrationAddModal: FunctionComponent<Props> = props => {
  const { isOpen, onCloseClick, items, onButtonClick } = props;
  if (!isOpen) return null;

  const hasICalendar = items.some(item => item.type === INTEGRATION_TYPE.I_CALENDAR);

  return (
    <SimpleModal
      isOpen={isOpen}
      title="Add integration"
      onCloseClick={onCloseClick}
      showFooter={false}
      customClass="integrationModal"
    >
      <div className="integrationPicker">
        <p>Choose the service you want to connect to your school account.</p>
        <div className="integrationPicker__grid">
          {OPTIONS.map(option => {
            const disabled = option.type === INTEGRATION_TYPE.I_CALENDAR && hasICalendar;
            return (
              <button
                key={option.type}
                type="button"
                disabled={disabled}
                onClick={event => onButtonClick && onButtonClick(event, option.type)}
              >
                <i>{option.mark}</i>
                <span>
                  <strong>{option.title}</strong>
                  <small>{disabled ? 'Already connected' : option.text}</small>
                </span>
                <b>→</b>
              </button>
            );
          })}
        </div>
        <div className="integrationPicker__footer">
          <button type="button" onClick={onCloseClick}>
            Cancel
          </button>
        </div>
      </div>
    </SimpleModal>
  );
};

IntegrationAddModal.displayName = 'IntegrationAddModal';
